import React, { Fragment } from 'react'
import styled from 'styled-components'

const ApiPath = ({ attributes, children, element, editor }) => <Path {...attributes}>{children}</Path>

export default ApiPath

const Path = styled.div`
  font-family: monospace;
  background: ${props => props.theme.bgLightestInverse};
  padding: 8px 12px;
  font-size: 0.945rem;
  border-radius: 4px;
  margin-bottom: 20px;
  font-weight: 500;
  color: ${props => props.theme.textGreyTintedDarker};
`
